import { render } from "./TheScreen1.vue?vue&type=template&id=6f3e6f16&scoped=true"
import script from "./TheScreen1.vue?vue&type=script&lang=js"
export * from "./TheScreen1.vue?vue&type=script&lang=js"

import "./TheScreen1.vue?vue&type=style&index=0&id=6f3e6f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3e6f16"]])

export default __exports__